export var DeliveryChannel;

(function (DeliveryChannel) {
  DeliveryChannel["WEB"] = "WEB";
  DeliveryChannel["NATIVE_IOS"] = "NATIVE_IOS";
  DeliveryChannel["NATIVE_ANDROID"] = "NATIVE_ANDROID";
})(DeliveryChannel || (DeliveryChannel = {}));